// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import 'myWorld/base/control';
import 'jquery-ui';
import 'myWorld/controls/search/suggestionItemView';

myw.SearchExamplesView = myw.Control.extend({
    className: 'search-examples rounded5',
    events: {
        mousedown: 'cancelBlur'
    },
    /**
     * @class Responsible for rendering the search examples list and the Recent searches list <br/>
     * @param  {Application}  owner
     * @param  {array<string>}    options.searchExamples   List of search examples configured via the config settings
     * @param  {jQueryElement}    options.underneath       The search input element used to position the examples view
     * @constructs
     * @extends {Control}
     */
    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);

        this.searchExamples = options.searchExamples || [];

        this.examplesList = $("<ul class='noStyleList'></ul>");

        this.$el.html(this.examplesList).appendTo('body');

        myw.appReady.then(() => {
            const underneathEl = this.options.underneath,
                top = underneathEl.offset().top + underneathEl.outerHeight();
            this.$el.css({
                top: top,
                left: underneathEl.offset().left
            });

            this.owner._setContainerWidth(this.$el);
            this._setListHeight(top);

            $(window).resize(() => {
                this._setListHeight(top);
            });
        });

        this.recentSearches = this.owner.recentSearches;
        this.render();
    },

    _setListHeight(top) {
        this.$el.css('max-height', $(window).height() - top - 12);
        this.examplesList.css('max-height', 'inherit');
    },

    render() {
        this.examplesList.empty();
        this.examplesList.scrollTop(0);
        this._index = 0;

        if (this.recentSearches.length > 0) {
            // Add a header
            this.examplesList.append(
                `<li class='provider-title'>${this.owner.msg('recent_searches_header')}</li>`
            );

            const recentSearchesToDisplay = _.first(
                this.recentSearches,
                this.owner.options.maxRecentSearchesShown
            );

            _.each(recentSearchesToDisplay, searchItem => {
                // Setup the example searches.
                const options = {
                    index: this._index,
                    suggestion: searchItem,
                    owner: this.owner,
                    type: 'recent'
                };

                const suggestionView = new myw.SuggestionItemView(options);

                this.examplesList.append(suggestionView.$el);

                this._index++;
            });
        }
        if (this.searchExamples.length > 0) {
            // Add a header
            this.examplesList.append(
                `<li class='provider-title'>${this.owner.msg('search_examples_header')}</li>`
            );

            _.each(this.searchExamples, example => {
                // Setup the example searches.
                this.examplesList.append(
                    `<li class="example"><span>${_.escape(example)}</span></li>`
                );
            });
        }
    },

    /**
     * Shows the examples view if show=true else hides it
     * @param  {boolean} show
     */
    toggle(show) {
        const anythingToShow = this.searchExamples.length > 0 || this.recentSearches.length > 0;
        if (anythingToShow && show) {
            this.render();
            this.$el.show();
        } else {
            this.$el.hide();
        }
        this.resetHighlight();
    },

    /**
     * Filters the recent searches based on the searchText provided and updates the this.recentSearches property
     * @param  {string} searchText  Test entered in the search input
     */
    filterRecentSearches(searchText) {
        let filteredRecentSearches = [];
        if (searchText.length > 0) {
            _.each(this.owner.recentSearches, searchItem => {
                if (_.indexOf(searchItem.label.toLowerCase(), searchText.toLowerCase()) >= 0) {
                    filteredRecentSearches.push(searchItem);
                }
            });
        } else {
            filteredRecentSearches = this.owner.recentSearches;
        }
        this.recentSearches = filteredRecentSearches;
    },

    resetHighlight() {
        if (
            typeof this.owner.highlightedIndex === 'undefined' ||
            this.owner.allSuggestions().length === 0
        )
            this.owner.setHighlightedIndex(0);
    },

    cancelBlur(e) {
        this.owner.cancelBlur = true;
    }
});
export default myw.SearchExamplesView;
